<div
  [formGroup]="controlContainer.control"
  class="social-info-group"
>
  <div
    [formArrayName]="controlName"
    *ngFor="let link of getParentControl().controls; let i = index"
  >

    <div class="social-info-select-type">
      <mat-form-field
        class="social-media-type"
        [color]="color"
        [formGroupName]="i"
      >
        <mat-label>Social media type</mat-label>
        <mat-select
          formControlName="socialMediaType"
          [name]="'socialMediaType' + i"
          [(ngModel)]="selected[i]"
        >
          <mat-option
            *ngFor="let item of validSocialInfo"
            [value]="item.url"
          >
            {{ item.domain }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field
        class="social-media-url"
        [formGroupName]="i"
        [color]="color"
      >
        <mat-label>URL</mat-label>
        <input
          type="url"
          matInput
          formControlName="url"
          [name]="'url' + i"
        />
        <mat-error *ngIf="hasError(i)">
          {{ getErrorMsg(i) }}
        </mat-error>
        <button
          *ngIf="i === getParentControl().controls.length - 1 && !!link.value.url"
          (click)="addSocialInfo(i + 1)"
          matSuffix
          mat-mini-fab
          class="special special-accent"
          type="button"
        >
          <mat-icon>add</mat-icon>
        </button>
        <button
          *ngIf="getParentControl().controls.length > 1"
          (click)="removeSocialInfo(i)"
          matSuffix
          mat-mini-fab
          class="ml-1 special special-warn"
          type="button"
        >
          <mat-icon>remove</mat-icon>
        </button>
      </mat-form-field>
    </div>

  </div>
</div>
